import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import WarrantiesIcon from "@redotech/redo-icons/shield-tick.svg";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { NEEDS_ACTION } from "@redotech/redo-return-operations-common/views/needs-action";
import { ViewTypesNames } from "@redotech/redo-views-common/views";
import { createWarrantyListAdvancedFilters } from "../../returns-filters";
import { CLAIM_CARD_COPY } from "./claim-card-copy";
import { returnRecordSource } from "./return-record-source";

export const WARRANTIES_SOURCE = returnRecordSource({
  type: "warranties",
  recordType: ReturnTypeEnum.WARRANTY,
  Icon: WarrantiesIcon,
  availability: {
    capabilities: ["warranties"],
    permissions: [ReturnsAndClaimsPermissions.MANAGE_WARRANTY],
  },
  viewType: ViewTypesNames.WARRANTIES,
  countSavedViews: false,
  category: "returns",
  tableFilters: ({ language, merchantRpcClient }) =>
    createWarrantyListAdvancedFilters({ language, merchantRpcClient }),
  entries: NEEDS_ACTION.warranties,
  cardCopy: CLAIM_CARD_COPY,
  copy: (t) => ({
    recordsLabel: t("Warranties"),
    allLabel: t("All warranties"),
    searchAllLabel: (query) =>
      t("Search all warranties for “{{query}}”", { query }),
    recordCount: (count) => t("{{count}} warranties", { count }),
    viewRecords: (count) => t("View {{count}} warranties", { count }),
    viewLabel: t("View warranties"),
    processAll: (count) => t("Process all {{count}} warranties", { count }),
    resolvePrompt: (count, view) =>
      `Resolve the ${count} warranty claims flagged “${view}”`,
  }),
  create: ReturnTypeEnum.WARRANTY,
});
